import { createBrowserRouter } from 'react-router-dom';
import { BaseLayout } from './components/layouts/BaseLayout';
import { DashboardPage } from './components/pages/DashboardPage';
import { PayoutsPage } from './components/pages/PayoutsPage';
import { SettingsPage } from './components/pages/SettingsPage';
import { PlusValuesPage } from './components/pages/PlusValuesPage';
import { PrixVentePage } from './components/pages/PrixVentePage';
import { SimulatorFlatTaxPage } from './components/pages/SimulatorFlatTaxPage';
import { LoginPage } from './components/pages/LoginPage';
import { RegisterPage } from './components/pages/RegisterPage';

export const router = createBrowserRouter([
  // Public auth routes (no layout)
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/register',
    element: <RegisterPage />,
  },
  // App routes (with BaseLayout — accessible in Guest mode too)
  {
    path: '/',
    element: <BaseLayout />,
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
      {
        path: 'payouts',
        element: <PayoutsPage />,
      },
      {
        path: 'parametres',
        element: <SettingsPage />,
      },
      {
        path: 'plus-values',
        element: <PlusValuesPage />,
      },
      {
        path: 'prix-vente',
        element: <PrixVentePage />,
      },
      {
        path: 'simulateur-flat-tax',
        element: <SimulatorFlatTaxPage />,
      },
    ],
  },
]);
